<template>
	<input
		v-model="val"
		:type="type"
		:name="name"
		:placeholder="placeholder"
		:class="[classes]"
		:id="id"
		@input="$emit('input', val)"
		/>
	<!--<small :id="'err-' + id" class="form-text text-muted alertLabel">{{ errmsg }}</small>-->
</template>

<script>
	export default {
		name: "InputRegular",
		data() {
			return {
				val: "",
				errmsg: "",
				
				regexType: {
					alphanumeric: new RegExp(/[#@!$\\%^&*()_+|~=`{}\[\]:";<>?\/]*$/),
					email: new RegExp(/[,#!$\\%^&*()+|~=`{}\[\]:";<>?\/]*$/),
				},
				patternType: {
					email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
				}
			}
		},
		props: [
			"type",
			"name",
			"placeholder",
			"classes",
			"id",
			"values",
			"validationType",
			"checkPattern"
		],
		watch: {
			val: function (v) {
				if (v === "" || v === undefined) {
					return
				}

				var regexType;
				if (this.validationType === "alphanumeric") {
					regexType = this.regexType.alphanumeric;
				} else if (this.validationType === "email") {
					regexType = this.regexType.email;
				}

				if (this.checkPattern) {
					this.validatePattern(this.checkPattern)
				}

				this.val = v.replace(regexType, "");
				if (this.val.length === 1) {
					this.validateResult(true)
				}
			},
			values: function (v) {
				this.val = v
			},
		},
		methods: {
			validateResult(valid, errmsg = "") {
				return
				if (valid) {
					this.errmsg = ""
					$('#err-' + this.id)
						.removeClass("labeldanger")
						.addClass("alertLabel");
					$('#' + this.id).removeClass("inputAlertDanger");
				} else {
					this.errmsg = errmsg
					$('#err-' + this.id)
						.removeClass("alertLabel")
						.addClass("labeldanger")
					$('#' + this.id).addClass("inputAlertDanger");
				}
			},
			validatePattern(patternType) {
				var valid = false;
				var errmsg = ""
				if (patternType === "email") {
					errmsg = "*Email yang anda inputkan tidak valid"
					valid = this.patternType.email.test(this.val)
				}

				this.validateResult(valid, errmsg)
				return valid
			},
		},
	}
</script>

<style scoped>
	.alertLabel {
		display: none;
	}
	
	.labeldanger {
		/*margin-top: -10px !important;*/
		color: red !important;
		margin-bottom: 15px !important;
		font-size: 13px;
	}
	
	.inputAlertDanger {
		border-color: red !important;
	}
</style>